import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { DgMktCampaignContainerModel } from '../../../../../../models/aggregates/dgmkt/dgmkt-campaign/dgmkt-campaign-container.model';
import { ApiResponseModel, ApiVisa } from '../../shared';
import { Observable } from 'rxjs';
import { bl_dgmkt_campaign_hdr_RowClass } from '../../../../../../models';

@Injectable({
  providedIn: 'root',
})
export class DgMktCampaignService extends BaseApiTemplateService<DgMktCampaignContainerModel> {
  readonly url =
    Core2Config.TENANT_DOMAIN_URL_PREFIX +
    Core2Config.DGMKT_MODULE_PREFIX +
    'campaigns';

  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.DGMKT_MODULE_PREFIX +
      'campaigns';
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.DGMKT_MODULE_PREFIX +
      'campaigns';
    this.httpClient = http;
  }

  public getCampaignSummaryByGuid(
    guid: string,
    visa: ApiVisa
  ): Observable<ApiResponseModel<bl_dgmkt_campaign_hdr_RowClass>> {
    let { apiUrl } = this;
    if (this.endpoint_path && visa.api_domain_url) {
      apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<
      ApiResponseModel<bl_dgmkt_campaign_hdr_RowClass>
    >(apiUrl + `/summary/${guid}`, this.getHttpHeader(visa));
  }

  public executeCampaign(
    guid: string,
    visa: ApiVisa
  ): Observable<ApiResponseModel<bl_dgmkt_campaign_hdr_RowClass>> {
    let { apiUrl } = this;
    if (this.endpoint_path && visa.api_domain_url) {
      apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<
      ApiResponseModel<bl_dgmkt_campaign_hdr_RowClass>
    >(apiUrl + `/execute/${guid}`, this.getHttpHeader(visa));
  }

  public executeCampaignBySchedule(
    campaignGuid: string,
    visa: ApiVisa,
    limit?: number  
  ): Observable<ApiResponseModel<bl_dgmkt_campaign_hdr_RowClass>> {
    const apiUrl = (this.endpoint_path && visa.api_domain_url) 
      ? visa.api_domain_url + this.endpoint_path 
      : this.apiUrl;
  
    let url: string;
    if (limit !== undefined && limit !== null && limit > 0) {
      url = `${apiUrl}/schedule-execute/backoffice-ep/${campaignGuid}?limit=${limit}`;
    } else {
      url = `${apiUrl}/schedule-execute/backoffice-ep/${campaignGuid}`;
    }
  
    return this.httpClient.get<ApiResponseModel<bl_dgmkt_campaign_hdr_RowClass>>(
      url,
      this.getHttpHeader(visa)
    );
  }
  
  
}
